__turbopack_context__.v({
  "error-card": "ICc-vq_error-card",
  "error-card__content": "ICc-vq_error-card__content",
  "error-card__cta": "ICc-vq_error-card__cta",
  "error-card__heading": "ICc-vq_error-card__heading",
  "error-card__icon": "ICc-vq_error-card__icon",
});
